import * as React from 'react';

import { POPULAR_CITIES } from './constants';
import { getGeolocation } from '../../../../browser/utils/getGeolocation';
import { getRegionsByPoint } from '../../../services/getRegionsByPoint';
import { getSuggestions } from '../../../services/getSuggestions';
import { TResultSuggestion } from '../../../types/suggest';
import { useApplicationContext } from '../../../utils/applicationContext';
import { useDebouncedCallback } from '../../../utils/useDebouncedCallback';

export function useGeoSuggest() {
  const context = useApplicationContext();
  const [suggestions, setSuggestions] = React.useState<TResultSuggestion[] | null>(POPULAR_CITIES);
  const [isLoadingSuggestions, setLoadingSuggestions] = React.useState<boolean>(false);
  const [isLoadingGeolocation, setLoadingGeolocation] = React.useState<boolean>(false);

  const getSuggestionsDebounced = useDebouncedCallback(async (value: string) => {
    if (!value) {
      setSuggestions(POPULAR_CITIES);

      return;
    }

    setLoadingSuggestions(true);
    const suggestionsData = await getSuggestions(context, value);
    const suggestionsNext = suggestionsData && suggestionsData.length > 0 ? suggestionsData : POPULAR_CITIES;
    setSuggestions(suggestionsNext);
    setLoadingSuggestions(false);
  }, 300);

  const handleGetGeolocation = React.useCallback(async () => {
    setLoadingGeolocation(true);

    try {
      const { coords } = await getGeolocation();
      const regions = await getRegionsByPoint(context, {
        lat: coords.latitude,
        lng: coords.longitude,
      });

      setLoadingGeolocation(false);

      return regions[0].displayName;
    } catch (ex) {
      setLoadingGeolocation(false);

      throw ex;
    }
  }, [context]);

  return {
    suggestions,
    getSuggestions: getSuggestionsDebounced,
    getGeolocation: handleGetGeolocation,
    isLoading: isLoadingSuggestions || isLoadingGeolocation,
  };
}
